import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useContext } from 'react'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const retornaLocalAtendimento = (u = []) => ({
  idFluxoAtendimento: u?.[0] || undefined,
  nmFluxoAtendimento: u?.[1] || '',
  dtExclusao: u?.[3] || '',
})

const createAgenda = z.object({
  idFluxoAtendimento: z.number().optional(),
  nmFluxoAtendimento: z.string().min(3, {
    message: 'Nome inválido',
  }),
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados, localAtendimento[0]),
  })

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('nmFluxoAtendimento')}
            label="Nome"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.nmFluxoAtendimento}
            helperText={errors.nmFluxoAtendimento?.message}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
